import { useTheme } from '@mui/material/styles';
import { createMakeStyles } from "../makeStyles.js";
export const { makeStyles } = createMakeStyles({
    useTheme,
});
